import script from "./QuickAccessSection.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickAccessSection.vue?vue&type=script&setup=true&lang=js"

import "./QuickAccessSection.vue?vue&type=style&index=0&id=35288578&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35288578"]])

export default __exports__